/** Export menu entries shown under Shell toolbar → Export. */
export const shellExportMenuItems = [
  {
    key: 'exportExcelVisible',
    label: 'Export visible',
    tabs: ['table'],
  },
  {
    key: 'exportExcelAll',
    label: 'Export all employees',
    tabs: ['table'],
  },
  {
    key: 'exportTemplate',
    label: 'Download import template',
    tabs: ['table'],
  },
  {
    key: 'exportCsv',
    label: 'Export CSV',
    tabs: ['departments', 'positions'],
  },
  {
    key: 'exportImage',
    label: 'Print current view',
    tabs: ['tree'],
  },
  {
    key: 'exportFullTree',
    label: 'Download full tree HTML',
    tabs: ['tree'],
  },
];
